if (!customElements.get('timeline-slider')) {
  class TimelineSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = new Swiper(this.querySelector('[data-slider]'), {
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
        slidesPerView: 1,
      });
    }
  }

  customElements.define('timeline-slider', TimelineSlider);
}
